export const getFallbackImageUrl = (name) => {
  const encodedName = encodeURIComponent(name);
  return `https://ui-avatars.com/api/?background=e11d48&color=fff&name=${encodedName}&size=512&bold=true`;
};